module.exports = __webpack_public_path__ + "img/file11.d176bda4.png";